<ng-container *ngIf="isCreateMode() || isUpdateMode()">
  <form (ngSubmit)="save()" [formGroup]="form">
    <base-form-header
      [mode]="mode"
      createLabel="Ajouter un contact interne"
      updateLabel="Modifier l'affectation"
    ></base-form-header>

    <mat-dialog-content fxLayout="column">
      <base-form-input
        label="Contact"
        controlName="contact"
        type="autocomplete"
        [items$]="contacts$"
        (autocompleteChange)="contactChange($event)"
        displayProperty="fullName"
      ></base-form-input>

      <ng-container *ngIf="issupportEstablishment">
        <base-form-input
          *ngIf="!canReadMode"
          label="Type de contact fournisseur"
          type="multiple"
          controlName="contactTypes"
          [items]="contactTypes"
          displayProperty="label"
        ></base-form-input>
      </ng-container>

      <base-form-input
        label="Responsable"
        controlName="responsable"
        type="autocomplete"
        [items$]="responsables$"
        (autocompleteChange)="responsableChange($event)"
        displayProperty="fullName"
      ></base-form-input>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <base-form-input
        type="submit"
        [mode]="mode"
        [loading]="loading"
        entityLabel="USER"
        (onCreate)="createItem()"
      ></base-form-input>
    </mat-dialog-actions>
  </form>
</ng-container>
